module.exports = __webpack_public_path__ + "img/Frame9405.1838078d.svg";